let material = null

const setMaterials = (data) => {
    material = data;
}

const getMaterials = () => {
    return material
}

export {
    setMaterials,
    getMaterials
}